import {Form, Select, Spin} from 'antd';
import React, {useEffect} from 'react';

import {InstantlyFormLabel} from './InstantlyFormLabel';
import {InfoIcon} from '../icons';
import {STRINGS} from '../../utils';
import {FormRow} from '../formComponents';

const {Option} = Select;

interface InstantlyFormItemProps {
  errors: any;
  touched: any;
  values: any;
  isTokenVerified: boolean;
  campaigns: any[];
  openSettings: () => void;
  getCampaigns: () => void;
  isLoading: boolean;
  onChangeCampaigns: (values: string[]) => void;
  tags?: any[];
  onChangeTags?: (values: string[]) => void;
}

export const InstantlyFormItem = ({
  errors,
  touched,
  values,
  isTokenVerified,
  campaigns,
  openSettings,
  getCampaigns,
  isLoading,
  onChangeCampaigns,
  tags = [],
  onChangeTags,
}: InstantlyFormItemProps) => {
  useEffect(() => {
    getCampaigns();
  }, [isTokenVerified]);

  return (
    <div className="instantly-acquisition-form-item">
      <Spin spinning={isLoading}>
        <InstantlyFormLabel onClick={openSettings} showConnect={!isTokenVerified} />
        {isTokenVerified && (
          <>
            <FormRow>
              <Form.Item
                label={<span>Campaigns</span>}
                validateStatus={errors.instantly_campaign_ids && touched.instantly_campaign_ids ? 'error' : ''}
                hasFeedback
                help={
                  errors.instantly_campaign_ids && touched.instantly_campaign_ids ? errors.instantly_campaign_ids : ''
                }
              >
                <Select
                  mode="multiple"
                  style={{width: '100%'}}
                  placeholder="Select Instantly Campaign"
                  value={values.instantly_campaign_ids}
                  onChange={onChangeCampaigns}
                >
                  {campaigns.map((c: any) => (
                    <Option key={c.id}>{c.name}</Option>
                  ))}
                </Select>
              </Form.Item>
            </FormRow>
            {onChangeTags && (
              <FormRow>
                <Form.Item
                  label={
                    <span>
                      Filter by Receiver Tags <InfoIcon message={STRINGS.tooltip.instantly_acquisition_tags} />
                    </span>
                  }
                  hasFeedback
                >
                  <Select
                    mode="tags"
                    style={{width: '100%'}}
                    placeholder="Select tags"
                    value={values.instantly_tags_ids}
                    onChange={onChangeTags}
                  >
                    {tags.map((tag: any) => (
                      <Option key={tag.id}>{tag.name}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </FormRow>
            )}
          </>
        )}
      </Spin>
    </div>
  );
};
